// Turn any axios/FastAPI error into a plain string (422 detail arrays would otherwise crash React).
export function formatApiError(e, fallback = 'Something went wrong. Please try again.') {
  const d = e && e.response && e.response.data && e.response.data.detail;
  if (!d) return (e && e.message) || fallback;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((x) => (typeof x === 'string' ? x : [(x.loc || []).slice(-1)[0], x.msg].filter(Boolean).join(': '))).join('; ') || fallback;
  if (typeof d === 'object') return d.msg || d.message || JSON.stringify(d);
  return String(d);
}
